
<div class="ms-2 head-icons" tabindex="0">
  <a href="javascript:void(0);"  (click)="toggleCollapse()" (keydown.enter)="toggleCollapse()" [ngClass]="{'active': isCollapsed}" class=""  placement="top" tooltip="Collapse"  id="collapse-header">
    <i class="ti ti-chevrons-up"></i>
  </a>
</div>
